import { ComponentClass } from 'react';

import InputBase from './Base';
import { CoreFormElementUrl } from '../../../components/';

/**
 * Url Input Controller
 * @export
 * @class UrlInputController
 * @extends {InputBase}
 */
export default class UrlInputController extends InputBase {
  /**
   * Controlled Element
   * @override
   * @static
   * @memberof UrlInputController
   */
  public static ControlledElement: ComponentClass<any> = CoreFormElementUrl;
}
